/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuildMembership } from './GuildMembership';
import {
    GuildMembershipFromJSON,
    GuildMembershipFromJSONTyped,
    GuildMembershipToJSON,
    GuildMembershipToJSONTyped,
} from './GuildMembership';
import type { NftOwnership } from './NftOwnership';
import {
    NftOwnershipFromJSON,
    NftOwnershipFromJSONTyped,
    NftOwnershipToJSON,
    NftOwnershipToJSONTyped,
} from './NftOwnership';
import type { TopGuildLeaderLeaderboard } from './TopGuildLeaderLeaderboard';
import {
    TopGuildLeaderLeaderboardFromJSON,
    TopGuildLeaderLeaderboardFromJSONTyped,
    TopGuildLeaderLeaderboardToJSON,
    TopGuildLeaderLeaderboardToJSONTyped,
} from './TopGuildLeaderLeaderboard';
import type { Guild } from './Guild';
import {
    GuildFromJSON,
    GuildFromJSONTyped,
    GuildToJSON,
    GuildToJSONTyped,
} from './Guild';

/**
 * User's guild badges and data of all the guilds .
 * @export
 * @interface GetGuildOwnershipResponse
 */
export interface GetGuildOwnershipResponse {
    /**
     * 
     * @type {Array<NftOwnership>}
     * @memberof GetGuildOwnershipResponse
     */
    badges: Array<NftOwnership>;
    /**
     * 
     * @type {Array<Guild>}
     * @memberof GetGuildOwnershipResponse
     */
    qualifiedGuilds: Array<Guild>;
    /**
     * 
     * @type {Array<Guild>}
     * @memberof GetGuildOwnershipResponse
     */
    otherGuilds: Array<Guild>;
    /**
     * 
     * @type {GuildMembership}
     * @memberof GetGuildOwnershipResponse
     */
    membership?: GuildMembership;
    /**
     * 
     * @type {GuildMembership}
     * @memberof GetGuildOwnershipResponse
     */
    lastMembership?: GuildMembership;
    /**
     * 
     * @type {Array<TopGuildLeaderLeaderboard>}
     * @memberof GetGuildOwnershipResponse
     */
    membersAroundUser?: Array<TopGuildLeaderLeaderboard>;
}

/**
 * Check if a given object implements the GetGuildOwnershipResponse interface.
 */
export function instanceOfGetGuildOwnershipResponse(value: object): value is GetGuildOwnershipResponse {
    if (!('badges' in value) || value['badges'] === undefined) return false;
    if (!('qualifiedGuilds' in value) || value['qualifiedGuilds'] === undefined) return false;
    if (!('otherGuilds' in value) || value['otherGuilds'] === undefined) return false;
    return true;
}

export function GetGuildOwnershipResponseFromJSON(json: any): GetGuildOwnershipResponse {
    return GetGuildOwnershipResponseFromJSONTyped(json, false);
}

export function GetGuildOwnershipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGuildOwnershipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'badges': ((json['badges'] as Array<any>).map(NftOwnershipFromJSON)),
        'qualifiedGuilds': ((json['qualifiedGuilds'] as Array<any>).map(GuildFromJSON)),
        'otherGuilds': ((json['otherGuilds'] as Array<any>).map(GuildFromJSON)),
        'membership': json['membership'] == null ? undefined : GuildMembershipFromJSON(json['membership']),
        'lastMembership': json['lastMembership'] == null ? undefined : GuildMembershipFromJSON(json['lastMembership']),
        'membersAroundUser': json['membersAroundUser'] == null ? undefined : ((json['membersAroundUser'] as Array<any>).map(TopGuildLeaderLeaderboardFromJSON)),
    };
}

export function GetGuildOwnershipResponseToJSON(json: any): GetGuildOwnershipResponse {
    return GetGuildOwnershipResponseToJSONTyped(json, false);
}

export function GetGuildOwnershipResponseToJSONTyped(value?: GetGuildOwnershipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'badges': ((value['badges'] as Array<any>).map(NftOwnershipToJSON)),
        'qualifiedGuilds': ((value['qualifiedGuilds'] as Array<any>).map(GuildToJSON)),
        'otherGuilds': ((value['otherGuilds'] as Array<any>).map(GuildToJSON)),
        'membership': GuildMembershipToJSON(value['membership']),
        'lastMembership': GuildMembershipToJSON(value['lastMembership']),
        'membersAroundUser': value['membersAroundUser'] == null ? undefined : ((value['membersAroundUser'] as Array<any>).map(TopGuildLeaderLeaderboardToJSON)),
    };
}

